import { render, staticRenderFns } from "./income2.vue?vue&type=template&id=3595f339"
import script from "./income2.vue?vue&type=script&lang=js"
export * from "./income2.vue?vue&type=script&lang=js"
import style0 from "./income2.vue?vue&type=style&index=0&id=3595f339&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports